/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_hamwi = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hamwi`)
};

const es_iw_hamwi = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hamwi`)
};

const de_iw_hamwi = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hamwi`)
};

const nl_iw_hamwi = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hamwi`)
};

const fr_iw_hamwi = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hamwi`)
};

const it_iw_hamwi = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hamwi`)
};

const pt_br2_iw_hamwi = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hamwi`)
};

const pt_iw_hamwi = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hamwi`)
};

const ja_iw_hamwi = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハムウィ式`)
};

const zh_iw_hamwi = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hamwi`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_hamwi = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_hamwi(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_hamwi", locale)
	if (locale === "en") return en_iw_hamwi(inputs)
	if (locale === "es") return es_iw_hamwi(inputs)
	if (locale === "de") return de_iw_hamwi(inputs)
	if (locale === "nl") return nl_iw_hamwi(inputs)
	if (locale === "fr") return fr_iw_hamwi(inputs)
	if (locale === "it") return it_iw_hamwi(inputs)
	if (locale === "pt-BR") return pt_br2_iw_hamwi(inputs)
	if (locale === "pt") return pt_iw_hamwi(inputs)
	if (locale === "ja") return ja_iw_hamwi(inputs)
	return zh_iw_hamwi(inputs)
};